import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { activitySearchSchema } from "@/features/activity/activity-search"
import { ActivityLog } from "@/features/activity/components/activity-log"
import { activityQueries } from "@/queries/activity"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/activity/"
)({
  validateSearch: activitySearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps, params }) =>
    context.queryClient.ensureInfiniteQueryData(
      activityQueries.feed({ type: "firm", id: params.firmId }, deps)
    ),
  component: FirmActivityPage,
})

function FirmActivityPage() {
  const { firmId } = Route.useParams()
  const filters = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <>
      <PageHeader title="Activity log" />
      <ActivityLog
        subject={{ type: "firm", id: firmId }}
        filters={filters}
        onFiltersChange={(search) => {
          void navigate({ replace: true, search })
        }}
      />
    </>
  )
}
